import create from 'zustand';

export enum ModalNames {
  COMPOSE_ERROR_LINK = 'COMPOSE_ERROR_LINK',
  SECURITIES_REGISTER = 'SECURITIES_REGISTER',
  STREAM_POST_LIMIT = 'STREAM_POST_LIMIT',
}

interface ModalState {
  activeModal: ModalNames | null;
  title: string;
  type: string;
  openModal: (modalName: ModalNames, title?: string, type?: string) => void;
  closeModal: () => void;
}

const useModalStore = create<ModalState>((set) => ({
  activeModal: null,
  title: '',
  type: '',
  openModal: (modalName, title = '', type = '') =>
    set({ activeModal: modalName, title, type }),
  closeModal: () => set({ activeModal: null, title: '', type: '' }),
}));

export default useModalStore;
